import React, { useCallback } from 'react';
import { IconCirclePlus } from 'src/content/icons';
import { strings } from 'src/localization';
import css from './AddVehicleCard.module.scss';
import classNames from 'classnames';
import { THEME } from 'src/constants/ThemeNames';


export interface IProps {
    // The selected flag is used for styling
    selected?: boolean;
    theme: string;
    // The clickVehicle prop will receive a string with the id of the vehicle clicked
    clickVehicle: (id: string, e: any) => void;
}

const AddVehicleCard = (props: IProps) => {
    // If selected include the selected class for styling
    const classes = classNames(
        css.vehicle,
        {
            [css.selected]: (props.selected),
            [css.selectedAcura]: props.selected && props.theme === 'acura',
            [css.vehicleAudi]: props.theme === THEME.AUDI,
        },
    );
    const AddVehicleId = 'AddVehicle';
    const keyFunction = useCallback((e) => {
        if (e.keyCode === 32 || e.keyCode === 13) {
            props.clickVehicle(AddVehicleId, e);
        }
    }, [props.clickVehicle]);

    const CSSh4VehCard = classNames(
        css.h4VehCard,
        {
            [css.h4VehCardAcura]: props.theme === 'acura',
            [css.h4VehCardAlt]: props.theme === 'mercedesBenz',
            [css.h4VehCardAlt2]: props.theme === 'bmw' || props.theme === 'ford' || props.theme === 'buick' ||
            props.theme === 'chevorlet' || props.theme === 'infiniti',
            [css.h4VehCardAltFntWt]: props.theme === 'bmw' || props.theme === 'ford' || props.theme === 'infiniti',
            [css.fontFamilyBaseFamily]: props.theme === 'mercedesBenz',
        },
    );
    const CSSplusIcon = classNames(
        css.plusIcon,
        {
            [css.plusIconAlt]: props.theme === 'bmw' || props.theme === 'ford' || props.theme === 'mercedesBenz',
            [css.plusIconAlt2]: props.theme === 'chevrolet' || props.theme === 'buick' || props.theme === 'infiniti' ||
                props.theme === 'acura',
        },
    );

    return (
        <div id='AddVehicleCard'
            className={classes}
            onClick={(e) => props.clickVehicle(AddVehicleId, e)}
            onKeyDown={(e) => keyFunction(e)}
            tabIndex={0}>
            <IconCirclePlus className={CSSplusIcon} />
            <div className={css.addVehicle}>
                <h4 className={CSSh4VehCard}>{strings.AddNewVehicle}</h4>
            </div>
        </div>
    );
};
export default AddVehicleCard;
